<script context='module'>
  import { getContext } from 'svelte';

  export const CONTEXT_KEY = Symbol('SseProvider.CONTEXT_KEY');
  export const useSse = () => getContext(CONTEXT_KEY);
</script>

<script>
  import Provider from '@commercebear/components/Provider';
  import { useSse as createSse } from '$util/sse';

  const sse = createSse('/jobs/status');
</script>

<Provider key={CONTEXT_KEY} value={sse}>
  <slot />
</Provider>
